export const skippableRule = {
  id: 'skippable',
  name: 'Skippable Ad Behavior',
  description: 'If ad is skippable, skip state should change after offset',

  check(session) {
    const adStarted = session.events.find(e => e.type === 'adstarted');
    if (!adStarted) {
      return { status: 'na', message: 'No ad started' };
    }

    // Check if the ad was skippable based on state snapshots
    const skippableSnapshot = session.stateSnapshots.find(s => s.state?.isSkippableAd);
    const skipStateChange = session.events.find(e => e.type === 'adskippablestatechanged');
    const adSkipped = session.events.find(e => e.type === 'adskipped');

    if (!skippableSnapshot && !skipStateChange) {
      return { status: 'na', message: 'Ad is not skippable' };
    }

    if (!skipStateChange) {
      return { status: 'fail', message: 'Ad marked as skippable but adskippablestatechanged never fired' };
    }

    let message = 'Skip state changed correctly';
    if (adSkipped) {
      message += ` — ad was skipped at ${adSkipped.timestamp}ms`;
    }

    return { status: 'pass', message };
  },
};
